module.exports = __webpack_public_path__ + "assets/blog/images/kursus-aabne-ordrer.jpg";